const CollectionConfig = {

    tokenName: "ProjectHVN",
    tokenSymbol: 'HVN',
    baseMetadataURI: "ipfs://QmdN2LsGe35Skv8HJjjYQqtv2LNs43VS7zxQgcLPwHxYjd/",
    hiddenMetadataUri: 'ipfs://QmRSS8eUZAKWZHVw5ngnGza1sNpb8Xb5cf817eYQE2p95v/hidden.json',
    maxSupply: 3698,
    whitelistSale: {
        price: 0,
        maxMintAmountPerTx: 1,
    },
    preSale: {
        price: 0.02,
        maxMintAmountPerTx: 5,
    },
    publicSale: {
        price: 0.025,
        maxMintAmountPerTx: 5,
    },
    contractAddress: null,
    marketplaceIdentifier: 'my-nft-token',
    whitelistAddresses: [ ],
};

module.exports = { CollectionConfig };
